/**
 * @description Cycle for invoicing payments
 */
enum InvoicingCycleEnum {
  Monthly = "Monthly",
  Yearly = "Yearly",
}

export default InvoicingCycleEnum;
